import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from 'react-intl'

export function PaymentDescription() {
  const intl = useIntl()

  return <Typography>{intl.formatMessage({ id: 'payment_scope_booking_payment_page_description' })}</Typography>
}
